import { SchoolInfoTypes } from "./schoolInfo.types";

const INITAIL_STATE = {
  //Fetch ClassBase List
  classBaseListData: null,
  isFetchingClassBaseList: false,
  errorFetchingClassBaseList: null,
  //Fetch Class List
  classListData: null,
  isFetchingClassList: false,
  errorFetchingClassList: null,
  //Fetch Course List
  courseListData: null,
  isFetchingCourseList: false,
  errorFetchingCourseList: null,
  //Fetch Student List
  studentListData: [],
  isFetchingStudentList: false,
  errorFetchingStudentList: null,
};

const schoolInfoReducer = (state = INITAIL_STATE, action) => {
  switch (action.type) {
    //Fetch ClassBase List
    case SchoolInfoTypes.FETCH_CLASSBASE_START:
      return {
        ...state,
        isFetchingClassBaseList: true,
        errorFetchingClassBaseList: false,
      };
    case SchoolInfoTypes.FETCH_CLASSBASE_SUCCESS:
      return {
        ...state,
        isFetchingClassBaseList: false,
        classBaseListData: action.payload,
      };
    case SchoolInfoTypes.FETCH_CLASSBASE_FAILURE:
      return {
        ...state,
        isFetchingClassBaseList: false,
        errorFetchingClassBaseList: action.payload,
      };
    // Fetch Class List
    case SchoolInfoTypes.FETCH_CLASS_START:
      return {
        ...state,
        isFetchingClassList: true,
        errorFetchingClassList: undefined,
        studentListData: [],
      };
    case SchoolInfoTypes.FETCH_CLASS_SUCCESS:
      return {
        ...state,
        isFetchingClassList: false,
        classListData: action.payload,
      };
    case SchoolInfoTypes.FETCH_CLASS_FAILURE:
      return {
        ...state,
        isFetchingClassList: false,
        errorFetchingClassList: action.payload,
      };
    // Fetch Course List
    case SchoolInfoTypes.FETCH_COURSE_START:
      return {
        ...state,
        isFetchingCourseList: true,
        errorFetchingCourseList: false,
      };
    case SchoolInfoTypes.FETCH_COURSE_SUCCESS:
      return {
        ...state,
        isFetchingCourseList: false,
        courseListData: action.payload,
      };
    case SchoolInfoTypes.FETCH_COURSE_FAILURE:
      return {
        ...state,
        isFetchingCourseList: false,
        errorFetchingCourseList: action.payload,
      };
    // Fetch Student List
    case SchoolInfoTypes.FETCH_STUDENT_START:
      return {
        ...state,
        isFetchingStudentList: true,
        errorFetchingStudentList: false,
      };
    case SchoolInfoTypes.FETCH_STUDENT_SUCCESS:
      return {
        ...state,
        isFetchingStudentList: false,
        studentListData: action.payload,
      };
    case SchoolInfoTypes.FETCH_STUDENT_FAILURE:
      return {
        ...state,
        isFetchingStudentList: false,
        errorFetchingStudentList: action.payload,
      };

    case SchoolInfoTypes.EDIT_STUDENT_LIST:
      const { isAdd, student } = action.payload;
      let students = [];
      if (isAdd) {
        students = [...state.studentListData, student];
      } else {
        students = state.studentListData.filter(
          (studentItem) => studentItem.studentId !== student.studentId
        );
      }

      return {
        ...state,
        studentListData: students,
      };

    //
    case SchoolInfoTypes.RESET_ERRORS:
      return {
        ...state,
        errorFetchingCourseList: null,
        errorFetchingClassList: null,
        errorFetchingClassBaseList: null,
        errorFetchingStudentList: null,
      };

    default:
      return state;
  }
};

export default schoolInfoReducer;
